/**
 * @generated SignedSource<<f3c3e1961a46af39be5a3f22a7884f36>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Weekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY" | "%future added value";
export type summaryOneDeliveryOnboardingQuery$variables = Record<PropertyKey, never>;
export type summaryOneDeliveryOnboardingQuery$data = {
  readonly onedeliveryProfile: {
    readonly baceId: string;
    readonly deliveryWeekdays: ReadonlyArray<Weekday>;
    readonly preferredHub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly id: string;
        readonly name: string;
        readonly postalCode: string;
        readonly street: string;
      } | null | undefined;
    };
  } | null | undefined;
};
export type summaryOneDeliveryOnboardingQuery = {
  response: summaryOneDeliveryOnboardingQuery$data;
  variables: summaryOneDeliveryOnboardingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OnedeliveryProfile",
    "kind": "LinkedField",
    "name": "onedeliveryProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryWeekdays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "preferredHub",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "summaryOneDeliveryOnboardingQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "summaryOneDeliveryOnboardingQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "ba1bb941a9e13cd37ef30ff19f1678c4",
    "id": null,
    "metadata": {},
    "name": "summaryOneDeliveryOnboardingQuery",
    "operationKind": "query",
    "text": "query summaryOneDeliveryOnboardingQuery {\n  onedeliveryProfile {\n    baceId\n    deliveryWeekdays\n    preferredHub {\n      id\n      meta {\n        id\n        name\n        street\n        postalCode\n        city\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c009c73f99d25a465e93460e6fee21f6";

export default node;
